module.exports = function init(selector) {
    var selector = selector || 'a';

    var links = document.querySelectorAll(selector),
        linksArr = Array.prototype.slice.call(links);

    linksArr
        .filter(function(node) {
            return node.hostname && node.hostname !== document.location.hostname;
        }).forEach(function(node) {
            node.setAttribute('target', '_blank');
        });
};



//////////////////
// WEBPACK FOOTER
// ./lib/openExternalLinksNewWindow.js
// module id = 14
// module chunks = 0